import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

const sameText = (a, b) => (a ?? '').trim() === (b ?? '').trim();

// A location's name is often just the organization's name repeated; when that
// happens show it once. The title leads with the organization name, unless the
// caller is already listing one organization's services and wants the service
// name up front instead.
const cardHeading = (program, location, programNameAsTitle) => {
	const locationName = sameText(location.name, location.organization_name)
		? undefined
		: location.name;
	const [title, ...subtitle] = programNameAsTitle
		? [program.name, location.organization_name, locationName]
		: [location.organization_name, locationName, program.name];
	return { title, subtitle: subtitle.filter(Boolean) };
};

const ServiceCard = ({ program, programNameAsTitle = false }) => {
	// let allowsElectronicApplications = false;
	const isTandemOrgService = !!program?.ccAttributes?.coord_agency_id;
	const isNonHubPartner = !!program?.ccAttributes?.non_hub_partner;
	const acceptsElectronicReferralsTag = program?.tags.find(
		({ category }) => category === 'accepts_e_ref',
	);
	const acceptsElectronicReferrals = !!acceptsElectronicReferralsTag;
	const acceptsElectronicReferralsCurrently =
		acceptsElectronicReferralsTag?.properties.find(
			({ name }) => name === 'accepts_e_ref_currently',
		)?.value === '1';
	return (
		<div className="my-4 bg-white shadow-xl card">
			<div className="card-body">
				{program.locations.map((location) => {
					const { title, subtitle } = cardHeading(
						program,
						location,
						programNameAsTitle,
					);
					return (
						<div key={location.id}>
							<div className="text-xl text-primary">{title}</div>
							<div className="text-sm">
								{subtitle.map((line, index) => (
									<Fragment key={`${index}-${line}`}>
										{index > 0 && <br />}
										{line}
									</Fragment>
								))}
							</div>
						</div>
					);
				})}
				{program.physical_address.map((address) => (
					<div key={`${address.id}`}>
						{address.address_1} | {address.city}, {address.state_province},{' '}
						{address.postal_code}
					</div>
				))}
				<div className="text-primary">{program.program}</div>
				<div>{program.description}</div>
				<div>
					<strong>Serves:</strong> {program.service_area}
				</div>
				{/* <MoreDetails /> */}
				{program.ccAttributes?.allow_self_ref_ind === 0 && (
					<div className="mt-4 alert alert-warning" role="alert">
						<ExclamationTriangleIcon className="block w-6 h-6" />
						Not available for self-service applications.
					</div>
				)}
				{(acceptsElectronicReferrals ||
					isTandemOrgService ||
					isNonHubPartner) && (
					<button
						className="mt-4 btn btn-primary btn-sm btn-block"
						name="program"
						value={program.id}
						type="submit"
						disabled={
							isNonHubPartner
								? program.ccAttributes?.availability != 1
								: !acceptsElectronicReferralsCurrently
						}
					>
						Apply Electronically
					</button>
				)}
			</div>
		</div>
	);
};

ServiceCard.propTypes = {
	program: PropTypes.object.isRequired,
	// Leads the card with the service name rather than the organization name.
	programNameAsTitle: PropTypes.bool,
};

export default ServiceCard;
